import React, { ReactNode, memo } from 'react'

import { DefaultDialog } from '@surglogs-app/ui.dialog'
import { LogoScreenLoader } from '@surglogs-app/ui.loader'

import { useAuthToken, useExternalTokenAuthData } from '../hooks'
import { useAuthTranslation } from '../hooks/useAuthTranslation'

import { PrivateRouteSessionWrapper } from './PrivateRouteSessionWrapper'

interface ExternalRouteProps {
  children: ReactNode
  accessManagementApiVersion: string
}

export const ExternalRoute = memo(
  ({ accessManagementApiVersion, children }: ExternalRouteProps) => {
    const { t } = useAuthTranslation()
    const { isLoadingExternalUserAuthData, isUnauthorized } =
      useExternalTokenAuthData()
    const { token } = useAuthToken()

    if (isLoadingExternalUserAuthData) {
      return <LogoScreenLoader {...{ fullWidth: true }} />
    }

    if (!token || isUnauthorized) {
      return (
        <DefaultDialog
          {...{
            title: t('externalRoute.expiredToken.title'),
            text: t('externalRoute.expiredToken.description'),
          }}
        />
      )
    }

    return (
      <>
        <PrivateRouteSessionWrapper
          {...{
            apiVersion: accessManagementApiVersion,
            referrer: 'external',
          }}
        />
        {children}
      </>
    )
  },
)
